module.exports = __webpack_public_path__ + "img/bodega.8e6f7424.svg";